import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { ConfigurationService } from '../../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class DividendsComponentService {
  URl = this.ConfigService.getAPIBaseUrl() + 'api/Notes_Single_Statements'
  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }
  insertsinglestatementdetails(data: any) {
    return this.http.post(this.URl + '/Insertdata', data)
  }
  Getsinglestatementdetails(id: any, PageName: any) {
    //return this.http.get(this.URl + '/Getdata?id=' + id, +'?PageName='+ PageName)
    return this.http.get(this.URl + '/Getdata/' + id + '/' + PageName)
  }
  Getsinglestatementdetails_LY(id: any, PageName: any) {
    //return this.http.get(this.URl + '/Getdata?id=' + id, +'?PageName='+ PageName)
    return this.http.get(this.URl + '/Getdata_LY/' + id + '/' + PageName)
  }
}
